export const jobExperiences = [
  {
    company: "Matrix Aviation Portal",
    duration: "January, 2022 - present",
    designation: "Full-Stack Developer",
    responsibilities: `I'm responsible for managing projects in a
      startup environment.
      Building full-stack web and mobile applications
      with React JS, Flutter, Node JS, MongoDB,
      Docker, etc.
      Implemented email delivery with SendGrid and
      payments Stripe.`,
  },
  {
    company: "Alo Infotech",
    duration: "June, 2021 - November, 2021",
    designation: "Full-Stack Developer",
    responsibilities: `I was responsible for building Mobile
      applications and Web applications.
      React JS, Node JS, Flutter and MongoDB are
      some technologies I used to complete the
      projects.
      I managed to developed performant database
      designs.`,
  },
];
